import React, { useState, useMemo, useEffect } from 'react';

import { useRouter } from 'next/router';

import { CircularProgress, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import debounce from 'lodash/debounce';
import { func, bool } from 'prop-types';

import { Form, InputStyled, Button } from './styles';

function HeaderInput({ openSearchBox, searchRequest, clearSearch, isLoading }) {
  const [content, setContent] = useState('');
  const router = useRouter();

  const handleSearch = useMemo(
    () =>
      debounce((query) => {
        if (query.length > 1) {
          openSearchBox(true);
          searchRequest(query);
        } else {
          clearSearch();
          openSearchBox(false);
        }
      }, 500),
    [clearSearch, openSearchBox, searchRequest]
  );

  useEffect(() => {
    if (typeof document !== 'undefined') {
      const { value } = document.getElementById('input-search-header');

      if (value) setContent(value);
    }
  }, [handleSearch]);

  useEffect(() => {
    if (router.query.content) {
      setContent(router.query.content);
    }
  }, [router]);

  const onChange = ({ target }) => {
    handleSearch(target.value);
    setContent(target.value);
  };

  const onFocus = () => {
    if (content.length > 2) {
      openSearchBox(true);
    }
  };

  const onBlur = () => {
    setTimeout(() => {
      openSearchBox(false);
    }, 200);
  };

  return (
    <Form action="/busca">
      <InputStyled
        id="content-search"
        label="Procure por nome, marca, código..."
        variant="outlined"
        name="content"
        value={content}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder="Digite sua busca"
        autoComplete="off"
        inputMode="search"
        // disabled={disabledInput}
        inputProps={{ type: 'search', id: 'input-search-header' }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              {isLoading && <CircularProgress size={30} />}
              {!isLoading && (
                <Button type="submit" Icon={() => <SearchIcon />} title="Buscar" aria-label="Buscar" height="52px" />
              )}
            </InputAdornment>
          ),
        }}
      />
    </Form>
  );
}

HeaderInput.propTypes = {
  openSearchBox: func,
  searchRequest: func,
  clearSearch: func,
  isLoading: bool,
};

export default HeaderInput;
